import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ShopView from './components/views/shop';
import CheckoutView from './components/views/checkout';
import OrderView from './components/views/order';

export default class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={ShopView} />
        <Route path="/checkout" component={CheckoutView} />
        <Route exact path="/order" component={OrderView} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes.js